import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChargeService } from 'src/app/services/charge.service';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { Charge } from 'src/app/shared/models/Charge';
import { Tank } from 'src/app/shared/models/Tank';
import { User } from 'src/app/shared/models/User';

@Component({
  selector: 'app-charge-page',
  templateUrl: './charge-page.component.html',
  styleUrls: ['./charge-page.component.css']
})
export class ChargePageComponent implements OnInit {

  chargeForm: FormGroup;
  titulo = 'Nueva Carga para: ';
  tankName: string;
  tankId: number;
  id: number;
  currentDate: string;
  currentUser: User;



  constructor(private fb: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute, private _tankService: TankService,
    private userService: UserService, private chargeService: ChargeService, private datePipe: DatePipe) {
    this.chargeForm = this.initChargeForm();
    this.id = parseInt(this.activatedRoute.snapshot.paramMap.get('id'), 10);
  }

  ngOnInit() {
    this.initializeEditMode();
    this.currentDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.currentUser = this.userService.currentUser;


    this._tankService.getCurrentTank().subscribe((tank) => {
      this.tankName = tank.name;
      this.tankId = tank.id;
    });

  }

  saveCharge() {
    if (this.chargeForm.invalid) {
      return;
    }

    let charge: Charge = this.chargeForm.value;
    charge.tankId = this.tankId;
    charge.dateTime = new Date();
    charge.user = this.currentUser.id;
    charge.user_name = this.currentUser.name;
    console.log("usuario: ", this.currentUser, " ", this.currentUser.name);

    const saveOrUpdate = this.id
      ? this.chargeService.editCharge(this.id, charge)
      : this.chargeService.saveCharge(charge);


    saveOrUpdate.subscribe(
      () => {
        this._tankService.updateTankAvailable(this.tankId);
        this.router.navigate(['/charges']);
      }, (error) => {
        console.log(error);
        this.chargeForm.reset();
      }
    );
  }


  private initChargeForm(): FormGroup {

    return this.fb.group({
      dateTime: [''],
      amount: [''],
      chargeType: [''],
      person: [''],
      tankId: [''],
      businessName: [''],
      cuitNumber: [''],
      address: [''],
      driverName: [''],
      vehiclePlate: [''],
      invoiceNumber: [''],
    });
  }

  private initializeEditMode() {
    if (this.id) {
      this.titulo = 'Editar Carga';
      this.chargeService.getCharge(this.id).subscribe((data) => {
        this.chargeForm.patchValue(data);
      });
    }
  }
}
